import { useEffect, useState } from "react";
import { Star, Check, EyeOff, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError, fmtDate } from "./api";

const badge = {
  pendente: "bg-amber-100 text-amber-700",
  aprovada: "bg-military/10 text-military",
  oculta: "bg-military-dark/10 text-military-dark/50",
};

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.put(`/admin/reviews/${id}/status`, { status });
      toast.success("Avaliação atualizada");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir esta avaliação definitivamente?")) return;
    await api.delete(`/admin/reviews/${id}`).catch(() => {});
    toast.success("Avaliação excluída");
    load();
  };

  return (
    <div data-testid="admin-reviews">
      <h1 className="font-serif text-3xl md:text-4xl text-military-dark mb-2">Avaliações</h1>
      <p className="text-sm text-military-dark/50 mb-8">Só entram aqui avaliações de clientes com compra confirmada. Aprove para exibir no site.</p>

      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} data-testid={`review-${r.id}`} className="bg-white border border-military/10 rounded-lg p-5">
            <div className="flex flex-wrap items-center gap-3 mb-2">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={14} className={i < r.rating ? "fill-military text-military" : "text-military/25"} />
                ))}
              </div>
              <p className="text-sm font-semibold text-military-dark">{r.name}</p>
              <span className="text-xs text-military-dark/40">{r.product_name} · {fmtDate(r.created_at)}</span>
              <span className={`text-[10px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-full ${badge[r.status] || badge.pendente}`}>{r.status}</span>
            </div>
            <p className="text-sm text-military-dark/70 leading-relaxed mb-4">{r.comment || "—"}</p>
            <div className="flex flex-wrap gap-2">
              {r.status !== "aprovada" && (
                <button data-testid={`approve-${r.id}`} onClick={() => setStatus(r.id, "aprovada")} className="flex items-center gap-1.5 rounded-full bg-military text-offwhite px-4 py-2 text-[10px] uppercase tracking-widest font-semibold hover:bg-military-dark transition-colors"><Check size={12} /> Aprovar</button>
              )}
              {r.status !== "oculta" && (
                <button data-testid={`hide-${r.id}`} onClick={() => setStatus(r.id, "oculta")} className="flex items-center gap-1.5 rounded-full border border-military/25 text-military-dark px-4 py-2 text-[10px] uppercase tracking-widest font-semibold hover:bg-baby transition-colors"><EyeOff size={12} /> Ocultar</button>
              )}
              <button data-testid={`delete-review-${r.id}`} onClick={() => remove(r.id)} className="flex items-center gap-1.5 rounded-full border border-red-200 text-red-700 px-4 py-2 text-[10px] uppercase tracking-widest font-semibold hover:bg-red-50 transition-colors"><Trash2 size={12} /> Excluir</button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <p className="text-sm text-military-dark/40">Nenhuma avaliação recebida ainda.</p>}
      </div>
    </div>
  );
}
